import UploadedStorageFiles from './UploadedStorageFiles';

export default UploadedStorageFiles;
